<div class="error-server-container" *ngIf="!isRapidScore">
  <div class="header" role = "banner"></div>
  <div class="left" role = "main">
    <div class="container-left">
      <div class="text-information"> <h1>{{ 'SUCCESS_PROCESS.DATA_OBTAINED' | translate }}</h1><span *ngIf="show">, {{ 'SUCCESS_PROCESS.CONTINUE' | translate }} </span></div>
      <button (click)="close()" id="againTry" *ngIf="show" type="submit">{{ 'SUCCESS_PROCESS.CONTINUE' | translate }}</button>
    </div>
  </div>
  <div class="right">
    <div class="imgs-container">
      <img class="oval" src="./assets/temporals/thinking_boy.svg" alt="">
    </div>
  </div>
  <div class="footer" role = "contentinfo">
    <button (click)="close()" id="againTry" *ngIf="show" type="submit">{{ 'SUCCESS_PROCESS.CONTINUE' | translate }}</button>
  </div>
</div>
<div class="error-server-container-rapidScore" *ngIf="isRapidScore">
  <header class="header" *ngIf="headerFooter"  role = "banner">
    <div class="container-logo">
      <div class="logo"><img src="{{ './assets/logos/Logo_SCF_red.png' }}" [ngStyle]="{'cursor': 'auto', 'width': '130px', 'padding': '0'}"  alt="Logo_SCF_red"></div>
    </div>
  </header>
  <div class="body" role = "main">
    <img src="./assets/login/success-rapidScore.png" alt="Imagen de éxito">
    <div class="message">
      <h1>{{ 'SUCCESS_PROCESS.GREAT' | translate }}</h1>
      <br>
      <p>{{ 'SUCCESS_PROCESS.SUCCESS' | translate }}<span *ngIf="show"> {{ 'SUCCESS_PROCESS.CONTINUE_REQUEST' | translate }}</span>.</p>
      <button (click)="close()" id="againTry" *ngIf="show" type="submit" aria-label="Button">{{ 'SUCCESS_PROCESS.CONTINUE' | translate }}</button>
    </div>
  </div>
</div>
